/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./cityPageCity.vue?vue&type=template&id=79806160&scoped=true"
import script from "./cityPageCity.vue?vue&type=script&lang=js"
export * from "./cityPageCity.vue?vue&type=script&lang=js"
import style0 from "./cityPageCity.vue?vue&type=style&index=0&id=79806160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79806160",
  null
  
)

export default component.exports